import i18n from 'i18next';
export const setActiveLanguage = async language => {
  await i18n.changeLanguage(language).then(async () => {
    await localStorage.setItem('I18N_LANGUAGE', language);
  });
};
